/* @flow */
import SchoolViewScreenshotFigures from './SchoolViewScreenshotFigures';

export default SchoolViewScreenshotFigures;
